import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "pressed", "today"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledDatePickerButton } from './DatePickerButton.styles';

/**
 * @related [`Button`, `DatePicker`]
 * @since 8.0.0
 */

export var DatePickerButton = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    pressed = _ref.pressed,
    today = _ref.today,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledDatePickerButton, _extends({
    ref: forwardedRef,
    "aria-pressed": pressed ? true : undefined
  }, props), children);
});
DatePickerButton.displayName = 'DatePickerButton';
DatePickerButton.propTypes = {
  children: PropTypes.node,
  pressed: PropTypes.bool,
  today: PropTypes.bool,
  /** @ignore */
  buttonType: PropTypes.string,
  /** @ignore */
  borderless: PropTypes.bool,
  /** @ignore */
  size: PropTypes.string
};
DatePickerButton.defaultProps = {
  children: null,
  pressed: false,
  today: false,
  buttonType: 'tertiary',
  borderless: true,
  size: 'sm'
};